import { render, staticRenderFns } from "./firmComplain.vue?vue&type=template&id=a86293c4&scoped=true&"
import script from "./firmComplain.vue?vue&type=script&lang=js&"
export * from "./firmComplain.vue?vue&type=script&lang=js&"
import style0 from "./firmComplain.vue?vue&type=style&index=0&id=a86293c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86293c4",
  null
  
)

export default component.exports